module.exports = __webpack_public_path__ + "officialStatic/img/product-dzbp.f929966.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/product-dzbp.png
// module id = Ag14
// module chunks = 0